import { render, staticRenderFns } from "./DevTest.vue?vue&type=template&id=6fc0826c&scoped=true"
import script from "./DevTest.vue?vue&type=script&lang=js"
export * from "./DevTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0826c",
  null
  
)

export default component.exports